import dayjs from 'dayjs';

// keep time selections on 15-minute increments
const forceTimeInterval = (time) => {
  if (!time && !dayjs.isDayjs(time)) {
    return null;
  }
  

  let selectedMin = time.minute;
  // console.log(`selectedMin: ${time.format('HH:mm')}`);
  if (selectedMin > 0 && selectedMin < 15) {
    adjustedMin = 0;
  } else if (selectedMin > 15 && selectedMin < 30) {
    adjustedMin = 15;
  } else if (selectedMin > 30 && selectedMin < 45) {
    adjustedMin = 30;
  } else if (selectedMin > 45) {
    adjustedMin = 45;
  } else {
    adjustedMin = selectedMin;
  }
  
  // console.log(`adjustedTime: ${adjustedTimeStr}`);
  let adjustedTime = time.minute(adjustedMin)
  // console.log(adjustedTime);

  return adjustedTime;
}

export default forceTimeInterval;
